interface ColorDotProps {
  color: string
  size?: 'sm' | 'md'
}

export function ColorDot({ color, size = 'md' }: ColorDotProps) {
  const sizeClass = size === 'sm' ? 'h-2 w-2' : 'h-3 w-3'
  return (
    <span
      className={`inline-block shrink-0 rounded-full ${sizeClass}`}
      style={{ backgroundColor: color }}
    />
  )
}
